// GENERATED FILE - DO NOT MODIFY

export enum GetFoodOrderDestinationsSortColumnDto {
    Name = "Name",
    Email = "Email",
}